export default __webpack_public_path__ + "9b340f16f7d67834158b4f27b0d37726.wav";